import api from "../services/api";

export default {
    namespaced: true,
    state: {
        loading: false,
        loadError: "",
        auditLogs: [],
        totalAuditLogs: 0,
        values: {
            auditLogValues: [],
            loading: false,
            loadError: "",
        }
    },
  
    getters: {
        loadInProgress(state) {
            return state.loading;
        },
        getAuditLogs(state) {
            return state.auditLogs;
        },
        getAuditLogValues(state) {
            return state.values.auditLogValues;
        }
    },
  
    mutations: {
        setAuditLogs(state, data) {
            state.auditLogs = data;
        },
        setTotalAuditLogs(state, data) {
            state.totalAuditLogs = data;
        },
        loading(state) {
            state.loading = true;
            state.loadError = "";
        },
        loadComplete(state) {
            state.loading = false;
        },
        loadError(state, err) {
            state.auditLogs = [];
            state.loadError = err;
        },
        setAuditLogValues(state, data) {
            state.values.auditLogValues = data;
        },
        loadingValues(state) {
            state.values.loading = true;
            state.values.loadError = "";
        },
        loadValuesComplete(state) {
            state.values.loading = false;
        },
        loadValuesError(state, err) {
            state.values.auditLogValues = [];
            state.values.loadError = err;
        }
    },
  
    actions: {
        loadAuditLogs(context, params) {
            context.commit("loading");

            api.fetchAuditLogs({
                params: params,
                success: function(response) {
                    context.commit("setAuditLogs", response.data.AuditLogs);
                    context.commit("setTotalAuditLogs", response.data.TotalAuditLogs);
                },
                error: function(e) {
                    context.commit("loadError", api.parseHttpRequestError(e));
                },
                finally: function() {
                    context.commit("loadComplete");
                }
            });
        },
        loadAuditLogValues(context, options){
            context.commit("loadingValues");

            api.fetchAuditLogValues({
                params: {
                    AuditLogID: options.AuditLog.ID
                },
                success: function(response) {
                    context.commit("setAuditLogValues", response.data.AuditLogValues);
                },
                error: function(e) {
                    context.commit("loadValuesError", api.parseHttpRequestError(e));
                },
                finally: function() {
                    context.commit("loadValuesComplete");
                }
            });
        }
    }
}
